import { trackEvent, EVENTS, EVENT_IDS } from "~/common/analytics"
import { Link } from "react-router-dom"
import logo from "~/images/landing/logo"

interface LogoProps {
  analyticsProps?: Record<string, string | undefined>
  className?: string
}

export const Logo = ({ analyticsProps = {}, className = "h-[40px]" }: LogoProps) => {
  const handleLogoPress = () => {
    trackEvent(EVENTS.ITEM_PRESSED, {
      unique_id: EVENT_IDS.LOGO,
      ...analyticsProps,
    })
  }
  return (
    <Link to="/" onClick={handleLogoPress}>
      <img src={logo.src} alt="Logo" className={className} />
    </Link>
  )
}
